import * as Yup from 'yup';

// Schema for coordinates
const coordinatesSchema = Yup.object().shape({
  latitude: Yup.number().required('Latitude is required'),
  longitude: Yup.number().required('Longitude is required'),
  altitude: Yup.number().required('Altitude is required'),
});

// Schema for options
const optionsSchema = Yup.object().shape({
  min: Yup.number().max(Yup.ref('max'), 'Min must be less than max').required('Min is required'),
  max: Yup.number().min(Yup.ref('min'), 'Max must be greater than min').required('Max is required'),
});

// Schema for value
const valueSchema = Yup.object().shape({
  creationType: Yup.string().required('Creation type is required'),
  generatorType: Yup.string().required('Generator type is required'),
  value: Yup.number().required('Value is required'),
});

// Schema for conditional validation
const conditionalValueSchema = Yup.object().shape({
  creationType: Yup.string().required('Creation type is required'),
  generatorType: Yup.string().required('Generator type is required'),
  value: Yup.number().when('creationType', {
    is: 'CONSTANT',
    then: Yup.number().required('Value is required.'),
    otherwise: Yup.number().notRequired(),
  }),
  options: Yup.object().when('creationType', {
    is: 'RANDOM',
    then: optionsSchema.required('Options are required for RANDOM type'),
    otherwise: Yup.object().notRequired(),
  }),
});

/**
 * Function: getConfigurationValidationSchema
 *
 * Returns the validation schema for a building information form (step1).
 *
 * @returns {Yup.ObjectSchema} The validation schema.
 */
export const getConfigurationValidationSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().optional(),
    location: Yup.object().shape({
      coordinates: coordinatesSchema.required('Coordinates are required'),
    }),
    rotation: Yup.object().shape({
      type: Yup.string()
        .required('Type is required')
        .oneOf(['ProjectNorth', 'TrueNorth']),
      angle: conditionalValueSchema.required('Angle is required'),
    }),
    height: Yup.object().shape({
      type: Yup.string()
        .required('Type is required')
        .oneOf(['FLOOR', 'BUILDING']),
      value: conditionalValueSchema.required('Value is required'),
    }),
    numberOfLevels: Yup.number().required('Value is required'),
    moduleSize: Yup.number().required('Module size is required'),
    modular: Yup.boolean().required('Modular flag is required'),
  });
};
